import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Text, View } from 'react-native';

const MissingPercentChange = () => {
  const [styles] = usePercentChangeContentStyles();

  return (
    <Text style={[styles.displayText, { color: styles.missingChange.color }]}>
      {i18n.t(
        'dsr_analytics.total_sales.table.percent_change_display.missing_change',
      )}
    </Text>
  );
};

const IncreasePercentChange = ({ percent }: { percent: number }) => {
  const [styles] = usePercentChangeContentStyles();

  return (
    <>
      <Text style={[styles.arrow, { color: styles.positive.color }]}>↑</Text>
      <Text style={[styles.displayText, { color: styles.positive.color }]}>
        {i18n.t(
          'dsr_analytics.total_sales.table.percent_change_display.change',
          { percent: Math.abs(percent) },
        )}
      </Text>
    </>
  );
};

const DecreasePercentChange = ({ percent }: { percent: number }) => {
  const [styles] = usePercentChangeContentStyles();

  return (
    <>
      <Text style={[styles.arrow, { color: styles.negative.color }]}>↓</Text>
      <Text style={[styles.displayText, { color: styles.negative.color }]}>
        {i18n.t(
          'dsr_analytics.total_sales.table.percent_change_display.change',
          { percent: Math.abs(percent) },
        )}
      </Text>
    </>
  );
};

const NoChange = () => {
  const [styles] = usePercentChangeContentStyles();

  return (
    <Text style={[styles.displayText, { color: styles.noChange.color }]}>
      {i18n.t(
        'dsr_analytics.total_sales.table.percent_change_display.no_change',
      )}
    </Text>
  );
};

const PercentChangeContent: React.FC<{
  percent: number | null | undefined;
}> = ({ percent }) => {
  if (percent === 0) {
    return <NoChange />;
  } else if (!percent) {
    return <MissingPercentChange />;
  } else if (percent > 0) {
    return <IncreasePercentChange percent={percent} />;
  } else if (percent < 0) {
    return <DecreasePercentChange percent={percent} />;
  }
};

export const PercentChangeDisplay: React.FC<{
  percent: number | null | undefined;
}> = ({ percent }) => {
  const [styles] = usePercentChangeDisplayStyles();
  return (
    <View style={styles.base}>
      <PercentChangeContent percent={percent} />
    </View>
  );
};

const usePercentChangeDisplayStyles = createStyles(() => ({
  base: {
    flexDirection: 'row',
    gap: 2,
  },
}));

const usePercentChangeContentStyles = createStyles((theme) => ({
  arrow: {
    fontFamily: theme.fonts.primaryBold,
    fontSize: 11,
  },
  displayText: {
    fontFamily: theme.fonts.primarySemiBold,
    fontSize: 11,
  },
  missingChange: {
    color: theme.colors.inactiveText,
  },
  negative: {
    color: theme.colors.negative,
  },
  noChange: {
    color: theme.colors.inactiveText,
  },
  positive: {
    color: theme.colors.darkGreen,
  },
}));
